import { useWidgetContext } from 'widgets/WidgetContext';
import { useSelectLocked } from 'layoutRenderer/store/selectors';
import { styleConstants } from './variables.module.constants';
import { useHistoricalPercentageChangeWidgetConfigSlice } from 'widgets/historicalPercentageChange/widget/store.ts';

export interface UseHistoricalPercentageChangeWidgetChartDimensionsRet {
    hideLegends: boolean;
    headerHeight: number;
    chartTop: number;
    chartHeight: number;
}
export function useHistoricalPercentageChangeWidgetChartDimensions(): UseHistoricalPercentageChangeWidgetChartDimensionsRet {
    const { height } = useWidgetContext();
    const { config } = useHistoricalPercentageChangeWidgetConfigSlice();

    const locked = useSelectLocked();

    const hidingAllLegends = config.hidePriceLegend && config.hideVolumeLegend;
    const hideLegends = locked && hidingAllLegends;

    let headerHeight = styleConstants.toolbarHeight;

    if (locked) {
        if (hidingAllLegends) {
            headerHeight = 0;
        }
    }

    const chartHeight = height - headerHeight - styleConstants.spaceAround * 2;
    const chartTop = headerHeight + styleConstants.headerMargin;

    return {
        hideLegends,
        headerHeight,
        chartHeight,
        chartTop,
    };
}
